import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AssessmentProvider } from "./context/AssessmentContext";
// ...existing code...
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./styles/theme.css";
import "./App.css";

// add this import
import { LeaveProvider } from './context/LeaveContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
     <React.StrictMode>
          <AssessmentProvider>
               <LeaveProvider>
                    <App />
               </LeaveProvider>
          </AssessmentProvider>
     </React.StrictMode>
);

